import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useGlobalState } from "../../contexts/GlobalContext";
import { Http, Routes } from "../../utils/constants";
import { ROUTE_LABELS } from "../../utils/constants/constant";
import Input from "../../components/Commons/Input";
import routes from "../../utils/constants/routes";
import { AxiosResponse } from "axios";
import {
  fetchChangePassword,
  checkEmailExists,
  fetchSendPasswordResetEmail
} from "../../utils/helpers/api";
interface IForgotPassword {
  email: string;
}
const ForgotPassword: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const { setStateValue } = useGlobalState();

  const [state, setState] = useState<IForgotPassword>({
    email: "",
  });
  const [errors, setErrors] = useState({
    email: "",
    isValid: false,
  });
  const [isSubmit, setIsSubmit] = useState<boolean>(false);
  const [errEmailNotExists, setErrEmailNotExists] = useState<boolean>(false);

  const handlerChangeValue = (field: string, value: string) => {
    setState((prevState) => ({
      ...prevState,
      [field]: value,
    }));

    // if (field === "email") {
    //   localStorage.setItem("resetPasswordEmail", value);
    // }
  };

  const validateForm = () => {
    let isValid = true;
    let newErrors = { email: "", isValid: true };

    if (state?.email) {
      if (!state.email.includes("@")) {
        newErrors.email = `メールアドレスに「＠」を挿入してください。「${state.email}」内に「＠」がありません`;
        isValid = false;
      } else {
        const atIndex = state.email.indexOf("@");
        const beforeAt = state.email.substring(0, atIndex);
        const afterAt = state.email.substring(atIndex + 1);

        if (beforeAt.length === 0) {
          newErrors.email = `「＠」の前の文字列を入力してください。「${state.email}」は完全なメールアドレスではありません。`;
          isValid = false;
        } else if (afterAt.length === 0) {
          newErrors.email = `「${state.email}」は完全なメールアドレスではありません。「＠」に続く文字列を入力してください。`;
          isValid = false;
        }
        // else if (!/^[a-zA-Z0-9]+$/.test(beforeAt)) {
        // const invalidChars = beforeAt.replace(/[a-zA-Z0-9]/g, "");
        //   newErrors.email = `「＠」の前の文字列に記号「${invalidChars}」を使用しないでください。`;
        //   isValid = false;
        // }
      }
    }
    setErrors((prevState) => ({
      ...prevState,
      email: newErrors.email,
      isValid: newErrors.isValid,
    }));
    return isValid;
  };

  const handlerCheckEmail = async (): Promise<boolean> => {
    try {
      const lowerCaseEmail = state.email.toLowerCase();
      const result = await checkEmailExists(lowerCaseEmail ?? "");
      const { exists } = result.data;

      setErrEmailNotExists(!exists);

      return exists;
    } catch (error) {
      console.error("Error checking email:", error);
      return false;
    } finally {
    }
  };

  const handlerSubmit = async () => {
    if (isSubmit) {
      navigate(routes.LOGIN);
      return;
    }

    const lowerCaseEmail = state.email.toLowerCase();

    if (!validateForm()) return;

    if (!lowerCaseEmail) {
      setState((prevState) => ({
        ...prevState,
        isShowErr: true,
      }));

      setErrors((prevState) => ({
        ...prevState,
        isValid: false,
        email: "メールアドレスを入力してください",
      }));

      return;
    }

    setStateValue("loader", true);

    try {
      const isExists = await handlerCheckEmail();
      if (!isExists) return;
      const result = (await checkEmailExists(
        lowerCaseEmail
      )) as AxiosResponse;

      if (result && result.data.exists) {
        const passwordResult = await fetchSendPasswordResetEmail(lowerCaseEmail);

        if (passwordResult?.status === Http.SUCCESS_CODE) {
          // localStorage.setItem("resetPasswordEmail", state.email);

          setState((prevState) => ({
            ...prevState,
            isSuccess: true,
          }));
        }

        setIsSubmit(true);
      } else {
        setState((prevState) => ({
          ...prevState,
          isValidate: false,
        }));
      }
    } catch (error: any) {
      if (error?.data && error?.data?.code === "SOCIAL_USER") {
        setErrors((prevState) => ({
          ...prevState,
          email: `お客様はGoogleアカウントを利用して会員登録されているため、当サービス上でのパスワード再設定は不要です。ログインの際は、引き続きGoogleアカウントでログインをご利用ください。`,
        }));
      }
      if (!(error instanceof Error)) {
        const res = error as AxiosResponse;
        return res;
      }
    } finally {
      setStateValue("loader", false);
    }
  };

  return (
    <div className="forgot-password-page">
      <section>
        <div className="l-head">
          <div className="step-info">
            <div className="page-title">
              {errEmailNotExists ? (
                <>
                  <span>パスワードの再設定</span>
                  <span className="note note-error">
                    {t("validation.emailNotExists")} <br />{" "}
                    {t("validation.emailAddressCorrectly")}
                  </span>
                </>
              ) : (
                <>
                  <span>
                    {!isSubmit
                      ? "パスワードの再設定"
                      : "パスワード再設定用メール送信完了"}
                  </span>
                  <span className="note">
                    {!isSubmit
                      ? "ご登録のメールアドレスを入力してください。パスワード再設定用のURLをメールでお送りします。"
                      : `${state.email} にパスワード再設定用のURLを記載したメールを送信しました。 メールに記載されているURLにアクセスし、新しいパスワードを設定してください。`}
                  </span>{" "}
                </>
              )}
            </div>
          </div>
        </div>
      </section>
      <section className="forgot-password-form">
        {!isSubmit ? (
          <div>
            <div className="form-items">
              <div className="form-item">
                <dt className="fi-label">
                  <label>
                    <span className="text">メールアドレス</span>
                  </label>
                </dt>
                <dd className="fi-control">
                  <Input
                    validateMess={errors.email}
                    error={errors.email}
                    placeholder="メールアドレス"
                    name="email"
                    id="email"
                    value={state.email}
                    onChange={(value) => {
                      handlerChangeValue("email", value);
                    }}
                    withChecked={true}
                  />
                </dd>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}
        <div>
          <div className="buttons">
            <button
              className={!isSubmit ? "btn-submit" : "btn-return"}
              onClick={handlerSubmit}
            >
              <span>{!isSubmit ? "送信" : "画面を閉じる"}</span>
            </button>
          </div>
        </div>
        {errEmailNotExists ? (
          <div className="page-title">
            <span className="note">
              {t("features.passwordRemind.newRegistration1")}
              <a style={{ textDecoration: "none" }} href={Routes.REGISTER}>
                {t("features.passwordRemind.newRegistration2")}
              </a>
              {t("features.passwordRemind.newRegistration3")}
            </span>
          </div>
        ) : (
          ""
        )}
      </section>
    </div>
  );
};

export default ForgotPassword;
